var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-field__errors"},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error.Key + error.SubfieldKey},[_vm._v(" "+_vm._s(error.Message)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }